import React from 'react';
import classNames from 'classnames';
import path from 'path';
import api from 'api';
import { PMS_URL } from '../../config';
import { AppLink } from '../modules/routing/containers';

class WebsiteMenu extends React.Component {
  constructor(props) {
    super(props);
    this.isActive = this.isActive.bind(this);
    this.isDropdownOpen = this.isDropdownOpen.bind(this);
    this.handleClickDropdown = this.handleClickDropdown.bind(this);
    this.state = {
      dropdowns: {
        content: false,
      }
    };
  }
  componentDidMount() {
    this.openDropdownFor(this.props.location.pathname);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.openDropdownFor(nextProps.location.pathname);
    }
  }
  render() {
    const root = '/website';
    return (
      <ul className="sidebar-menu">
        <li className={ classNames('treeview', { active: this.isDropdownOpen('content') }) }>
          <a href="#" onClick={ this.handleClickDropdown.bind(null, 'content') }>
            <i className="far fa-newspaper fa-fw"></i> <span>Texts and Medias</span><i className="fas fa-angle-left pull-right"></i>
          </a>
          <ul className="treeview-menu">
            <li className={ classNames({ active: this.isActive('/content/property-reviews') }) }>
              <AppLink to="/content/property-reviews" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Properties Reviews</span></AppLink>
            </li>
            <li className={ classNames({ active: this.isActive('/content/areas') }) }>
              <AppLink to="/content/areas" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Content for Areas</span></AppLink>
            </li>
            <li className={ classNames({ active: this.isActive('/content/listings') }) }>
              <AppLink to="/content/listings" customRoot={ root }><i className="fas fa-arrow-alt-circle-right fa-fw"></i> <span>Content for Listings</span></AppLink>
            </li>
          </ul>
        </li>
      </ul>
    );
  }

  isActive(url) {
    const [pathname, searchParams] = url.split('?');
    return this.props.location.pathname.match(`^${this.resolveUrl(pathname)}`)
      && this.props.location.search.match(searchParams);
  }
  isDropdownOpen(name) {
    return this.state.dropdowns[name];
  }
  openDropdownFor(url) {
    let name;
    if (url.match(`^${this.resolveUrl('/content')}`)) name = 'content';
    const dropdowns = Object.keys(this.state.dropdowns).reduce((object, _name) => ({ ...object, [_name]: false }), {});
    if (name) dropdowns[name] = true;
    this.setState({ dropdowns });
  }
  handleClickDropdown(name, evt = null) {
    if (evt) { evt.preventDefault(); }
    const dropdowns = { ...this.state.dropdowns };
    Object.keys(dropdowns)
      .filter(n => n !== name)
      .map(n => dropdowns[n] = false);
    dropdowns[name] = !dropdowns[name];
    this.setState({ dropdowns });
  }

  resolveUrl(url) {
    const currentUrl = path.join('/website', url);
    return PMS_URL === '/' ? currentUrl : `${PMS_URL}${currentUrl}`;
  }
}

WebsiteMenu.propTypes = {
  location: React.PropTypes.object,
};

export default WebsiteMenu;



// WEBPACK FOOTER //
// ./src/frontend/layout/WebsiteMenu.jsx